export default "__VITE_ASSET__D8Okg5Tl__"